import { render } from "./SlidingMenu.vue?vue&type=template&id=4d33bc84&scoped=true"
import script from "./SlidingMenu.vue?vue&type=script&lang=js"
export * from "./SlidingMenu.vue?vue&type=script&lang=js"

import "./SlidingMenu.vue?vue&type=style&index=0&id=4d33bc84&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d33bc84"]])

export default __exports__